import {
  Box,
  Heading,
  Text,
  Avatar,
  Divider,
  Stack,
  Badge,
  SimpleGrid,
  useColorModeValue,
  Input,
  Button,
} from '@chakra-ui/react';
// import TechnologyTable from './TechnologyTable';
import { useContext, useEffect, useState } from 'react';
import { UserInfoContext } from '../../provider/UserInfoProvider';
import { UseApi } from '../../libraries/UseApi';
import { UseMessage } from '../../libraries/UseMessage';
import { GetContractTypeOptionByValue, GetSexOptionByValue, GetUserTypeOptionByValue } from '../../components/options/GetOptionByValue';
import MyTechnologies from './MyTechnologies';
import axios from 'axios';

export default function UserProfilePage() {
  const [user, setUser] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const {token} = useContext(UserInfoContext);
  const { getApi } = UseApi();
  const {Message} = UseMessage();

  useEffect(() => {
      getProfileData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProfileData = () => {
      // 処置中チェック
      if (isProcessing) {
          // 処理中の場合、以降の処理を実施しない
          return;
      }
      // 処理中フラグをONにする
      setIsProcessing(true);


      // 未受検者検索API
      getApi(
          `${process.env.REACT_APP_API_URL}/me/profile`, {}, { token: token },
          (response) => {
              // 成功時
              if (response.isSuccess === false) {
                  // error
                  alert(Message.Common.ERROR);
                  // 処理中フラグを元に戻す
                  setIsProcessing(false);
                  return;
              }

              setUser(response.data);
              // 処理中フラグを元に戻す
              setIsProcessing(false);
          },
          () => {
              // 異常時
              // 処理中フラグをOFFにする
              setIsProcessing(false);
          }
      );
  };
  const bgColor = useColorModeValue('white', 'gray.700');

  const profileFields = [
    { label: '名前', value: user.name },
    { label: '名前カナ', value: user.name_kana },
    { label: 'メールアドレス', value: user.email },
    { label: 'ユーザタイプ', value: user.user_type },
    { label: '招待数', value: user.invite_count },
    { label: '支社', value: user.branch },
    { label: '部署', value: user.department },
    { label: '国', value: user.country },
    { label: '性別', value: GetSexOptionByValue(user.sex) },
    { label: '契約タイプ', value: GetContractTypeOptionByValue(user.contract_type) },
    { label: '生年月日', value: user.dob },
    { label: '参画可能日', value: user.available_from },
    { label: '郵便番号', value: user.post_code },
    { label: '住所', value: user.address },
    { label: '入社日', value: user.joining_date },
  ];

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('thumb', file);

    axios.post(`${process.env.REACT_APP_API_URL}/me/upload-thumb`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      // Update thumb state
      getProfileData(); // Refresh profile data to reflect the new thumb
    })
    .catch(() => alert('アップロード失敗'));
  };

  return (
    <Box p={{ base: 4, md: 8 }} bg={bgColor} borderRadius="xl" boxShadow="lg" maxW="7xl" mx="auto">
      {/* Header */}
      <Stack direction="row" spacing={6} align="center" mb={8}>
        <Box position="relative" w="fit-content">
          <Avatar
            size="2xl"
            name={user.name}
            src={`${process.env.REACT_APP_API_URL}/storage/${user.thumb}`}
            border="2px solid"
            borderColor="orange.400"
          />

          <Input
            type="file"
            accept="image/*"
            id="avatar-upload"
            display="none"
            onChange={handleFileChange}
          />

          <Button
            as="label"
            htmlFor="avatar-upload"
            size="xs"
            position="absolute"
            bottom={0}
            right={0}
            colorScheme="orange"
            borderRadius="full"
            boxShadow="md"
            _hover={{ boxShadow: 'lg' }}
            cursor={ 'pointer' }
          >
            編集
          </Button>
        </Box>

        <Box>
          <Heading size="lg">{user.name}</Heading>
          {user.short_description && (
            <Text color="gray.600" mt={1}>
              {user.short_description}
            </Text>
          )}
        </Box>
      </Stack>

      {/* Basic Info Grid */}
      <Heading size="md" mb={4} color="orange.500">
        基本情報
      </Heading>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6} mb={8}>
        {profileFields.map((item, idx) => (
          <Box key={idx}>
            <Text fontSize="sm" color="gray.500" mb={1}>
              {item.label}
            </Text>
            {item.label === 'ユーザタイプ' ? (
              <Badge mt={1} colorScheme="orange">
                {GetUserTypeOptionByValue(item.value)}
              </Badge>
            ) : (
              <Text fontWeight="medium">{item.value || '-'}</Text>
            )}
          </Box>
        ))}
      </SimpleGrid>

      <Divider mb={8} />

      {/* Technology Table */}
      <Box>
        <Heading size="md" mb={4} color="orange.500">
          技術スキル
        </Heading>
        <MyTechnologies />
      </Box>
    </Box>
  );
}
